import React, { useEffect } from "react";
import { Box, Text, VStack, Spinner } from "@chakra-ui/react";
import { AppEmbed, Page, useEmbedRef } from "@thoughtspot/visual-embed-sdk/react";
import { EmbedEvent } from "@thoughtspot/visual-embed-sdk";
import { useUser } from "../../context/UserContext";

const ThoughtSpotEmbed: React.FC = () => {
	const embedRef = useEmbedRef<typeof AppEmbed>();
	const [isLoading, setIsLoading] = React.useState(true);
	const [error, setError] = React.useState<string | null>(null);
	const { tsBaseUrl } = useUser();

	// this useEffect is to listen for ThoughtSpot post messages
	useEffect(() => {
		const handler = (event: MessageEvent) => {
			if (event.origin === tsBaseUrl) {
				console.log("ThoughtSpot postMessage:", event.data);
			}
		};

		window.addEventListener("message", handler);
		return () => window.removeEventListener("message", handler);
	}, []);

	return (
		<Box width="100%" minHeight="calc(100vh - 100px)" height="100%" bg="white" position="relative">
			{isLoading && (
				<VStack
					position="absolute"
					top="50%"
					left="50%"
					transform="translate(-50%, -50%)"
					spacing={4}
				>
					<Spinner size="xl" color="purple.500" thickness="4px" />
					<Text>Loading ThoughtSpot...</Text>
				</VStack>
			)}

			{error && (
				<VStack
					position="absolute"
					top="50%"
					left="50%"
					transform="translate(-50%, -50%)"
					spacing={4}
				>
					<Text color="red.500">Error loading ThoughtSpot: {error}</Text>
				</VStack>
			)}

			<AppEmbed
				ref={embedRef}
				pageId={Page.Data}  // Opens the "Data workspace" page
				showPrimaryNavbar={false}  // Hide ThoughtSpot's top navbar
				hideApplicationSwitcher={true}  // Hide app switcher
				disableProfileAndHelp={true}  // Hide profile menu
				frameParams={{
					width: "100%",
					height: "100%",
				}}
				onLoad={() => {
					setIsLoading(false);
					console.log("ThoughtSpot loaded successfully");

					embedRef.current?.on(EmbedEvent.CreateModel, (payload: any) => {
						console.log("Model saved", payload);
						// trigger UI after model saves
					});

					embedRef.current?.on(EmbedEvent.Alert, (payload: any) => {
						if (payload?.data?.alertMessage === "Table saved successfully.") {
							console.log("Table saved", payload);
							// trigger UI after table saves
						}
					});
				}}
				onError={(error: any) => {
					setIsLoading(false);
					setError(error?.message || "Unknown error");
					console.error("ThoughtSpot error:", error);
				}}
				style={{
					width: "100%",
					height: "100%",
				}}
				customizations={{
					style: {
						customCSS: {
							rules_UNSTABLE: {
								".footer-module__footerLogo": {
									display: "none !important" // Hide ThoughtSpot logo
								},
							}
						}
					}
				}}
			/>
		</Box>
	);
};

export default ThoughtSpotEmbed;